import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page63() {
  useEffect(() => {
    document.title = "Маяк — Страница 62"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page61" />
        <ForwardLink href="/page63" />
      </div>

      <p style={{ textAlign: "right" }}>62.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Ладно. Ваша взяла. Мне нравится<br/>
        Ваша стряпня.
      </p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – НОЧЬ</p>
      <p>Катастрофический шторм продолжается.</p>
      <p>Вспышка молнии.</p>
      <p>Ветер.</p>
      <p>Вспышка молнии.</p>
      <p>Дождь.</p>
      <p>Вспышка молнии.</p>
      <p>Волны.</p>
      <p>Вспышка молнии.</p>
      <p>Фогорн.</p>
      <p>Вспышка молнии.</p>
      <br/>
      <p>ВНУТРИ. МАЯК. МАШИННОЕ ОТДЕЛЕНИЕ – НОЧЬ</p>
      <p>
        КАМЕРА НАДВИГАЕТСЯ НА: МОЛОДОЙ наблюдает за светом через<br/>
        линзовую деку. Загипнотизированный.
      </p>
      <p>УЛЫБАЕТСЯ. ТРЯСЕТСЯ. СОШЕЛ С УМА?</p>
      <p>ШЕПОТ НАВЕРХУ. Или это просто вращающиеся линзы?</p>
      <p>Звук знакомый и чужой. Мужской и женский. Небесный.</p>
      <p>Он вытаскивает ОБЕДЕННЫЙ НОЖ и подносит его к свету...</p>
      <p>Улыбается, как фонарь из тыквы.</p>
      <p>Задержка.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. ПЕРЕХОД – УТРО</p>
      <p>
        МОЛОДОЙ снимает ботинки и кладет их в карманы, пятками<br/>
        вверх. Он крадется к БАШНЕ как грабитель<br/>
        в чулке.
      </p>
      <p style={{ textAlign: "right" }}>62.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page61" />
        <ForwardLink href="/page63" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710631675/the-lighthouse-script/wc56m5vogemk7mw7yeyd.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page63;
